__turbopack_context__.v({
  "airport": "SingleOfferCard-module-scss-module__jbQO8a__airport",
  "box": "SingleOfferCard-module-scss-module__jbQO8a__box",
  "button": "SingleOfferCard-module-scss-module__jbQO8a__button",
  "card": "SingleOfferCard-module-scss-module__jbQO8a__card",
  "code": "SingleOfferCard-module-scss-module__jbQO8a__code",
  "date_time": "SingleOfferCard-module-scss-module__jbQO8a__date_time",
  "destination": "SingleOfferCard-module-scss-module__jbQO8a__destination",
  "details": "SingleOfferCard-module-scss-module__jbQO8a__details",
  "details__offer_duration": "SingleOfferCard-module-scss-module__jbQO8a__details__offer_duration",
  "details__route": "SingleOfferCard-module-scss-module__jbQO8a__details__route",
  "flight": "SingleOfferCard-module-scss-module__jbQO8a__flight",
  "flight__image": "SingleOfferCard-module-scss-module__jbQO8a__flight__image",
  "flight__name": "SingleOfferCard-module-scss-module__jbQO8a__flight__name",
  "flight__type": "SingleOfferCard-module-scss-module__jbQO8a__flight__type",
  "flight_duration": "SingleOfferCard-module-scss-module__jbQO8a__flight_duration",
  "heading": "SingleOfferCard-module-scss-module__jbQO8a__heading",
  "more_info": "SingleOfferCard-module-scss-module__jbQO8a__more_info",
  "name": "SingleOfferCard-module-scss-module__jbQO8a__name",
  "price": "SingleOfferCard-module-scss-module__jbQO8a__price",
  "price_head": "SingleOfferCard-module-scss-module__jbQO8a__price_head",
});
